export const ListNumberPageDixièmes = [10,20,30,40,50,60,70,80,90]
export const ListNumberPagecentaines = [100,200,300,400,500,600,700,800,900]